import { render, staticRenderFns } from "./StepDomains.vue?vue&type=template&id=4bdfc406&"
import script from "./StepDomains.vue?vue&type=script&lang=js&"
export * from "./StepDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports